import { Injectable, Type } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IScratchPadDataPromiseLookupService } from "../IScratchPadDataPromiseLookupService";
import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { PromiseBlotterLookupService } from "../../impl/PromiseBlotterLookupService";

export abstract class ScratchPadDataPromiseLookupService
  extends PromiseBlotterLookupService<
    string,
    CubiqTS.LinkedOrderRequestImpl | CubiqTS.FixingOrderRequestImpl
  >
  implements IScratchPadDataPromiseLookupService
{
  constructor() {
    super();
  }

  abstract addOrderEntryReference(ref: string): Promise<boolean>;
  abstract removeOrderEntryReference(ref: string): Promise<boolean>;
  abstract hasOrderEntryReference(ref: string): Promise<boolean>;

  abstract getOrderData(reference: string): Promise<CubiqTS.OrderDataImpl>;
  abstract cloneItems(
    orderIds: string[],
  ): Promise<Array<CubiqTS.LinkedOrderRequestImpl | CubiqTS.FixingOrderRequestImpl>>;
}
